import { useQueryClient } from "@tanstack/react-query";
import { useSyncExternalStore } from "react";

import { serviceProblem, type ServiceProblem } from "./service-problems";

/** The first infrastructure problem reported by any query currently in error, or null. */
export function useActiveServiceProblem(): ServiceProblem | null {
  const cache = useQueryClient().getQueryCache();
  return useSyncExternalStore(
    (onChange) => cache.subscribe(onChange),
    () => {
      for (const query of cache.getAll()) {
        if (query.state.status === "error") {
          const problem = serviceProblem(query.state.error);
          if (problem) return problem;
        }
      }
      return null;
    },
  );
}
